import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/apps/blogtostart/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSelect"] */ "/root/apps/blogtostart/src/components/i18n-ui/language-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiI18nProvider"] */ "/root/apps/blogtostart/src/components/i18n-ui/provider.tsx");
